import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeartFilled } from "@ant-design/icons";
import { observer } from "mobx-react";
import { useStores } from "../../store/stores.js";
import { __, _i } from "../../utils/i18n.js";
const ConfigFooter = observer(()=>{
    const { optionStore: { publicUrl } } = useStores();
    return /*#__PURE__*/ _jsxs("div", {
        className: "rcb-config-footer",
        children: [
            _i(__("Real Cookie Banner is brought to you with {{icon/}} by"), {
                icon: /*#__PURE__*/ _jsx(HeartFilled, {
                    style: {
                        color: "#dca7a7"
                    }
                })
            }),
            /*#__PURE__*/ _jsx("a", {
                href: __("https://devowl.io/"),
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ _jsx("img", {
                    src: `${publicUrl}images/logos/devowl-with-text.svg`
                })
            })
        ]
    });
});
export { ConfigFooter };
